import { Component, Output, EventEmitter } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LoginDialogComponent } from 'app/modules/dialogs/login-dialog/login-dialog.component';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';

@Component({
  selector: 'app-blocked-user',
  templateUrl: './blocked_user.component.html',
  imports: [
    TranslocoPipe,
    FormsModule,
    MatIconModule
  ],
})
export class BlockedUserComponent {
  @Output() next = new EventEmitter<void>();
  email = '';
  public contactEmail: string = '';
  constructor(
    private translocoService: TranslocoService,
    private _dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private dialogUtilsService: DialogUtilsService,
  ) {}
  ngOnInit(){
    this.loadContactEmail();
  }

  private loadContactEmail(): void{
    try {

      if(!localStorage.getItem('currentCountryInfo')) {
        return;
      }

      const storedEmail = JSON.parse(localStorage.getItem('currentCountryInfo'))?.notifierMail;
      
      if (storedEmail) {
        this.contactEmail = storedEmail;
      }
    } catch (error) {
      console.error('Error loading contact email:', error);
    }
  }
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  continue() {
    if (this.email) this.next.emit();
  }
  closeDialog(): void {
    this.dialogUtilsService.closeDialog(this._dialogRef);
  }

  contactServicio(): void{
  }
  openRegisterDialog(): void {
    if (this._dialogRef) {
      // Close without animation
      this._dialogRef.close();
    }
  
    const { width, height } = this.dialogUtilsService.calculateDialogSize();
  
    this._dialogRef = this._dialog.open(LoginDialogComponent, {
      width: `${width}px`,

      maxWidth: '90vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      // Disable enter animation
      enterAnimationDuration: '0ms',
      // Disable exit animation
      exitAnimationDuration: '0ms'
    });
  
    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);
  
    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });      
    
  }
  shouldShowCloseButton(): boolean {
    return false;
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
  }
}